






























import BtnDefault from '@/components/UI/BtnDefault.vue';
import {Component, Vue, Watch} from 'vue-property-decorator';
import DialogFooter from '@/components/UI/DialogFooter.vue';
import {namespace} from 'vuex-class';
import IPlay from '@/components/icons/IPlay.vue'
import {baseUrl} from "@/service/ApiClient";
import {now} from "lodash";

const dialog = namespace('dialog')
const forms = namespace('forms')
const newshards = namespace('newshards')

@Component({
  components: {
    BtnDefault,
    DialogFooter,
    'i-play': IPlay,
  },
  name: "NoteEditForm"
})
export default class NoteEditForm extends Vue {

  @dialog.Getter('fullDialogShow') protected fullDialogShow: any
  @dialog.Mutation('SetFullDialogShow') protected SetFullDialogShow: any
  @forms.Getter('options') protected options:any
  @newshards.Action('editMediaAttachmentFromServerCompany') protected editMediaAttachmentFromServerCompany:any
  @newshards.Action('editMediaAttachmentFromServerPersonal') protected editMediaAttachmentFromServerPersonal:any
  @newshards.Action('addNoteCompany') protected addNoteCompany:any
  @newshards.Action('addNotePersonal') protected addNotePersonal:any

  baseURL:any =baseUrl()
  workspace:string = ''
  noteText:string = ''

  @Watch('fullDialogShow')
  getFullDialogShow(NewVal: any) {
      if(this.fullDialogShow) {
      this.workspace = this.$route.params.code
        this.noteText = ''
    }
  }
  created(){
    this.getFullDialogShow(true)
  }

  save() {

      if(this.workspace === 'personal') {

        this.addNotePersonal({
            params: {
              shardId: this.$route.query.id,
            },
            body: {
              type:"note",
              createdAtTimestamp:Date.now(),
              text: this.noteText
            }
        })
      } else {

        this.addNoteCompany({
            params: {
              CompanyCode: this.$route.params.code,
              shardId: this.$route.query.id,
            },
            body: {
              type:"note",
              createdAtTimestamp:Date.now(),
              text: this.noteText
            }
        })
      }
      this.SetFullDialogShow(false)

  }

}
